import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AgGridTableContainer from '../../../table/ag-grid-table-container';
import { reportsCustomGridOptions, TABLE_TYPES } from '../../../table/constants/table-options';
import { formatDate } from '../../../utils/common-utils';

export class MessageVolumeTable extends Component{
    buildColumns = () => {
        const { interval } = this.props;
        return [
            {
                field: 'date',
                headerName: 'Date',
                valueFormatter: ( params ) => formatDate( params.value, interval )
            },
            {
                field: 'percentReject',
                headerName: 'p=reject (% of total msg)',
                type: [
                    'rateColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'percentQuarantine',
                headerName: 'p=quarantine (% of total msg)',
                type: [
                    'rateColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'percentMonitor',
                headerName: 'p=none (% of total msg)',
                type: [
                    'rateColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'percentInvalid',
                headerName: 'Invalid Record (% of total msg)',
                type: [
                    'rateColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'percentNone',
                headerName: 'No Record (% of total msg)',
                type: [
                    'rateColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'total',
                headerName: 'Total Messages',
                type: [
                    'numberColumn',
                    'rightAlignColumn'
                ],
            },
        ];
    };

    render(){
        const { data, isExportingGridToCSV, exportToCSVSuccess, exportToCSVFailure } = this.props;

        return (
            <AgGridTableContainer
                columnDefs={this.buildColumns()}
                customGridOptions={reportsCustomGridOptions}
                dataAutomationId="reports-message-volume-table"
                exportCSVFileName="PolicyProgressA"
                exportToCSVFailure={exportToCSVFailure}
                exportToCSVSuccess={exportToCSVSuccess}
                isExportingGridToCSV={isExportingGridToCSV}
                rowData={data}
                tableType={`${TABLE_TYPES.BASIC} ${TABLE_TYPES.REPORTING}`}
                widgetId="messageVolume"
            />
        );
    };
};

MessageVolumeTable.propTypes = {
    data: PropTypes.array,
    exportToCSVFailure: PropTypes.func,
    exportToCSVSuccess: PropTypes.func,
    interval: PropTypes.string,
    isExportingGridToCSV: PropTypes.bool,
};

export default MessageVolumeTable;
